<template>
    <div class="vehicle-card">
        <div class="vehicle-status-badge" :class="getStatusBadgeClass()"></div>

        <div class="vehicle-image-container">
            <LoadingImage
                v-show="imageLoaded === false"
                :proportion="1.71"/>
            <img
                :src="`${vehicle.photo}`"
                class="vehicle-image"
                @load="imageLoaded = true"
                v-show="imageLoaded === true"/>
        </div>

        <div class="vehicle-info">
            <div class="vehicle-detail">
                <span class="detail-label">Veículo:</span>
                <span class="detail-value">{{ vehicle.model }}</span>
            </div>
            <div class="vehicle-detail">
                <span class="detail-label">Cor:</span>
                <span class="detail-value">{{ vehicle.color }}</span>
            </div>
            <div class="vehicle-detail">
                <span class="detail-label">Placa:</span>
                <span class="detail-value plate-highlight">{{ vehicle.board }}</span>
            </div>
            <div class="vehicle-detail">
                <span class="detail-label">Km:</span>
                <the-mask
                    disabled
                    class="km-display"
                    :value="vehicle.current_km"
                    :mask="['####', '#.###', '##.###', '###.###']"
                />
            </div>
            <div class="vehicle-branch">
                {{ vehicle.branch ? vehicle.branch.description : "" | truncate(15, "...") }}
            </div>
        </div>
    </div>
</template>
<script>
import LoadingImage from "../LoadingImage.vue";

export default {

    props: {
        vehicle: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    },

    components: {
        LoadingImage
    },

    data() {
        return {
            imageLoaded: false
        }
    },

    methods: {

        getStatusBadgeClass() { // getStatusBadgeClass - retorna classe para badge de status
            const statusClasses = {
                'patio': 'badge-available',
                'reservado': 'badge-reserved',
                'retirado': 'badge-progress',
                'devolvido': 'badge-completed',
                'bloqueado': 'badge-blocked',
                'pendencia': 'badge-pending',
                'pre_reserva': 'badge-pre-reserve'
            };
            return statusClasses[this.type] || 'badge-unknown';
        },
    }
}
</script>

<style scoped>

.vehicle-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    transition: all 0.3s ease;
    position: relative;
    border: 1px solid #e2e8f0;
}

.vehicle-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.vehicle-status-badge {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    z-index: 2;
}

/* Badges de status */
.badge-available {
    background: linear-gradient(90deg, #28a745, #20c997);
}

.badge-reserved {
    background: linear-gradient(90deg, #FE8D18, #0056b3);
}

.badge-progress {
    background: linear-gradient(90deg, #fd7e14, #e55100);
}

.badge-completed {
    background: linear-gradient(90deg, #343a40, #212529);
}

.badge-pending {
    background: linear-gradient(90deg, #dc3545, #c82333);
}

.badge-pre-reserve {
    background: linear-gradient(90deg, #8b00c7, #6a0099);
}

.badge-blocked {
    background: linear-gradient(90deg, #6c757d, #495057);
}

.vehicle-image-container {
    position: relative;
    height: 180px;
    overflow: hidden;
}

.vehicle-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.vehicle-card:hover .vehicle-image {
    transform: scale(1.05);
}

.vehicle-info {
    padding: 16px;
}

.vehicle-detail {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    font-size: 14px;
}

.detail-label {
    font-weight: 500;
    color: #6c757d;
}

.detail-value {
    font-weight: 600;
    color: #2c3e50;
}

.plate-highlight {
    background-color: #f8981d;
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-family: monospace;
    font-size: 12px;
    letter-spacing: 1px;
}

.km-display {
    border: none;
    background: transparent;
    text-align: right;
    font-weight: 600;
    color: #FE8D18;
    font-size: 14px;
    width: 100%;
    margin-right: -25px;
    padding-right: 25px;
}

.vehicle-branch {
    text-align: center;
    padding: 8px;
    background-color: #f8f9fa;
    border-radius: 6px;
    font-size: 12px;
    color: #6c757d;
    font-weight: 500;
    margin-top: 8px;
}

/* Estados de loading e vazio usando classes existentes */
.loading-state, .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
}

.loading-spinner, .empty-icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(135deg, #f8f9fa, #e9ecef);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    font-size: 2rem;
    color: #6c757d;
}

.loading-spinner i {
    color: #f8981d;
}

.loading-text, .empty-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
}

.empty-subtitle {
    color: #6c757d;
    font-size: 1rem;
}

/* Responsividade */
@media (max-width: 768px) {
    .home-admin-content {
        padding: 15px;
    }

    .dashboard-header-page {
        padding: 1.5rem;
        text-align: center;
    }

    .dashboard-title {
        font-size: 1.5rem;
    }

    .info-cards-grid {
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        gap: 10px;
    }

    .panel-header {
        flex-direction: column;
        gap: 15px;
        align-items: stretch;
    }

    .panel-actions {
        justify-content: center;
    }

    .vehicles-grid {
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 15px;
    }

    .legend-items {
        grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
        gap: 10px;
    }
}

@media (max-width: 576px) {
    .info-cards-grid {
        grid-template-columns: 1fr;
    }

    .vehicles-grid {
        grid-template-columns: 1fr;
    }

    .panel-actions {
        flex-direction: column;
    }

    .legend-items {
        grid-template-columns: repeat(2, 1fr);
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Report/VehicleCard.vue